import React from "react"
import IntlProps from "../../../state/helpers/IntlProps"
import { COST_METHOD_SECTION_MESSAGES } from "../../../utils/inventory"
import { injectIntl } from "react-intl"
import { StaticBackdrop } from "../../../common/modal"
import { CostMethodSelectorComponent } from "../../components"

export const CostMethod = injectIntl((props: IntlProps) => {
    return (
        <StaticBackdrop>
            <h5 className={"p-1 border-0"}>
                {props.intl.formatMessage(COST_METHOD_SECTION_MESSAGES["header"])}
            </h5>

            <CostMethodSelectorComponent/>
        </StaticBackdrop>
    )
})



// WEBPACK FOOTER //
// ./src/inventory/sections/settings/CostMethod.tsx